import React, { useState } from 'react'

const PREVIEW_ROW_LIMIT = 12

function DataCenterPreviewTable({ previewRows, previewLoading, previewIndicatorName, metadataRows }) {
  const [activeView, setActiveView] = useState('preview')

  const footText = previewLoading
    ? 'Loading a real data sample…'
    : previewRows.length === 0
      ? 'Make a selection to preview the file structure.'
      : `Showing ${previewRows.length} sample rows from real data for "${previewIndicatorName}" — full download will include all selected countries, indicators and periods.`

  return (
    <div className="dc-panel" id="dcReview">
      <div className="dc-panel-head">
        <div className="dc-panel-head-left">
          <span className="dc-badge-step" aria-hidden="true">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7-10-7-10-7Z" /><circle cx="12" cy="12" r="2.6" /></svg>
          </span>
          <div>
            <h2 className="dc-panel-title">Review</h2>
            <span className="dc-panel-sub">Sample of real data and indicator metadata before you export</span>
          </div>
        </div>
        <div className="dc-panel-tools">
          <button type="button" className={`dc-tool${activeView === 'preview' ? ' is-on' : ''}`} onClick={() => setActiveView('preview')}>Data preview</button>
          <button type="button" className={`dc-tool${activeView === 'metadata' ? ' is-on' : ''}`} onClick={() => setActiveView('metadata')}>Metadata</button>
        </div>
      </div>
      <div className="dc-panel-body">
        {activeView === 'preview' ? (
          <div className="dc-preview-wrap">
            <div className="dc-scroll">
              <table className="dc-table">
                <thead>
                  <tr>
                    <th>Country</th><th>Indicator</th><th>Frequency</th><th>Year</th>
                    <th style={{ textAlign: 'right' }}>Value</th><th>Unit</th><th>Transformation</th>
                    <th>Effective Unit</th><th>Source</th>
                  </tr>
                </thead>
                <tbody>
                  {previewRows.slice(0, PREVIEW_ROW_LIMIT).map((row, index) => (
                    <tr key={`${row.country}-${row.year}-${row.unit}-${row.transformation}-${index}`}>
                      <td>{row.country}</td>
                      <td className="dc-mono">{previewIndicatorName}</td>
                      <td>{row.frequency}</td>
                      <td>{row.year || row.period}</td>
                      <td className="dc-num">{row.value}</td>
                      <td>{row.unit}</td>
                      <td>{row.transformation || '—'}</td>
                      <td>{row.effective_unit}</td>
                      <td>{row.source}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="dc-preview-foot">
              <span>{footText}</span>
              <span>Long (tidy) format · one row per observation</span>
            </div>
          </div>
        ) : (
          <div className="dc-preview-wrap">
            <div className="dc-scroll">
              <table className="dc-table">
                <thead><tr><th>Indicator</th><th>Area</th><th>Topic</th><th>Available units</th><th>Available frequencies</th></tr></thead>
                <tbody>
                  {metadataRows.length === 0 && (
                    <tr><td colSpan={5}>No indicators selected.</td></tr>
                  )}
                  {metadataRows.map((row) => (
                    <tr key={row.indicator}>
                      <td className="dc-mono">{row.indicator}</td>
                      <td>{row.area}</td>
                      <td>{row.topic}</td>
                      <td>{row.units.join(', ') || '—'}</td>
                      <td>{row.frequencies.join(', ') || '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="dc-preview-foot">
              <span>{metadataRows.length === 0 ? 'No indicators selected.' : `${metadataRows.length} indicator(s) selected`}</span>
              <span>Included as a metadata sheet in the download</span>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default DataCenterPreviewTable
